module.exports = __webpack_public_path__ + "img/portrait-linkedin-after.aeab94c9.jpg";